<template>
    <BaseTooltip open-on-click side="top" :side-offset="8" content-class="max-w-80 p-3 text-left shadow-lg" :trigger-aria-label="triggerAriaLabel">
        <template #trigger>
            <button
                type="button"
                class="inline-flex size-7 shrink-0 items-center justify-center rounded-full text-valence-primary-600 transition-colors hover:bg-valence-primary-50 hover:text-valence-primary-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-valence-primary-600">
                <i class="bi bi-info-circle text-base" aria-hidden="true"></i>
            </button>
        </template>
        <template #content>
            <p v-if="regeneration" class="body-small">
                You already have a Collaboration Profile. Clicking Regenerate will replace your current profile with a new one based on these Perspective results.
            </p>
            <p v-else class="body-small">
                A shareable summary of how you work best. Sharing it helps teammates collaborate with you more effectively and gives Nadia the context to provide more personalized
                coaching.
            </p>
        </template>
    </BaseTooltip>
</template>

<script setup lang="ts">
import BaseTooltip from "~vue/components/BaseTooltip.vue";
import { computed } from "vue";

const { regeneration = false } = defineProps<{ regeneration?: boolean }>();

const triggerAriaLabel = computed(() => (regeneration ? "What happens when I regenerate my Collaboration Profile?" : "What is a Collaboration Profile?"));
</script>
